<template>
  <baidu-map id="mapContainer" ref="mapContainer" class="map" center="上海" :scroll-wheel-zoom="true" :mapStyle="mapStyle"
    @ready="ready">

    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>

    <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>

    <bm-map-type :map-types="['BMAP_NORMAL_MAP','BMAP_SATELLITE_MAP']" anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-map-type>

    <bm-marker v-if="dataType=='point'" v-for="(pnt,idx) in data" :key="idx" :position="pnt"></bm-marker>

    <bm-polyline v-else-if="dataType=='polyline'" v-for="(path,idx) in data" :key="idx" :path="path"></bm-polyline>

    <bm-polygon v-else-if="dataType=='polygon'" v-for="(path,idx) in data" :key="idx" :path="path"></bm-polygon>
  </baidu-map>
</template>
<script>
  export default {
    components: {},
    watch: {},
    data() {
      return {
        BMap: null, //BMap类
        map: null, //map实例
        mapStyle: {
          styleJson: [{
            featureType: "highway",
            elementType: "all",
            stylers: {
              weight: "0.1",
              visibility: "on"
            }
          }]
        },
        dataType: "",
        data: []
      };
    },
    created() {},
    mounted() {},
    methods: {
      ready(params) {
        this.BMap = params.BMap;
        this.map = params.map;
        // 将数据解析等操作放在这里，是因为需要用到百度地图的实例，而vue-baidu组件的地图实例在ready事件中获取
        this.dealURLParams(); //解析数据
        this.setViewport(); //设置视区为数据范围
      },
      dealURLParams() {
        /**
         * 以GET形式传递参数，URL中的参数有 
         * dataType（取值为point、polyline、polygon）
         * data（数据，xy坐标之间用“,”分割，不同点之间用“-”分割，不同线或者不同面之间用“;”分割）
         */
        let params = this.$route.query;
        this.data = [];
        this.dataType = params.type;
        //点
        if (this.dataType == "point") {
          this.data = this.parsePnts(params.data);
        }
        //折线、面
        if (this.dataType == "polyline" || this.dataType == "polygon") {
          //多条折线或者多个面之间用“;”分割
          this.data = params.data.split(";").map(pntsStr => {
            return this.parsePnts(pntsStr);
          })
        }
        console.log(this.data);
      },
      parsePnts(pntsStr) {
        //解析字符串，返回point类型（即对象{lng:x,lat:y}）数组
        //点为一维数组，线或者面为二维数组
        let rst = [];
        let pnts = pntsStr.split(","); //点之间用“,”分割
        for (let i = 0; i < pnts.length; i++) {
          let xy = pnts[i].split("-"); //x y坐标之间“-”分割
          rst.push({
            lng: Number(xy[0]),
            lat: Number(xy[1])
          })
        }
        return rst;
      },
      // 将地图当前显示范围设置为数据的分布范围
      setViewport() {
        let pnts = []; // 数据的点集，如果为线或者面，则表示折点
        for (let i = 0; i < this.data.length; i++) {
          if (Array.isArray(this.data[i])) {
            for (let j = 0; j < this.data[i].length; j++) {
              pnts.push(new this.BMap.Point(this.data[i][j].lng, this.data[i][j].lat));
            }
          } else {
            pnts.push(new this.BMap.Point(this.data[i].lng, this.data[i].lat));
          }
        }
        this.map.setViewport(pnts); // 调用百度地图实例的方法，参数为所有数据点的一个数组
      }
    }
  };

</script>
<style>
  .map {
    width: 100%;
    height: 100%;
  }

  .anchorBL {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/MapAPI.vue